import { Collection } from '@portal/core/types'
import React, { useMemo } from 'react'

import { StatContainer } from './HeaderStatContainer'

type Props = {
  isLoading: boolean
  collections: Collection[]
  children?: React.ReactNode
}

export default function AppCollectionsHeader({
  collections,
  isLoading,
  children,
}: Props) {
  const collectionsCount = useMemo(() => collections.length, [collections])

  if (isLoading) {
    return null
  }

  return (
    <div className="grid w-full grid-cols-12 items-start">
      <StatContainer label="Collections">{collectionsCount}</StatContainer>
      {children}
    </div>
  )
}
